import { useNavigate } from 'react-router-dom';

import { paths } from '@/app/router/paths';
import { useAcceptSubprojectInvitationStore } from '@/features/partners/store/use-accept-subproject-invitation-store';
import { FlowHeader } from '@/shared/components/flow/flow-header';

export const AcceptInvitationHeader = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const navigate = useNavigate();

  return (
    <FlowHeader
      onCancel={() => {
        useAcceptSubprojectInvitationStore.getState().reset();
        navigate(paths.home.getHref());
      }}
    >
      {children}
    </FlowHeader>
  );
};
